<h1 mat-dialog-title *ngIf="ShowFormAdd != true">Select Form Type</h1>
<h1 mat-dialog-title *ngIf="ShowFormAdd == true">Add new form</h1>



<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div *ngIf="ShowFormAdd != true">
    <div class="example-full-width" style="display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;height: 50px;">
      <div style="display: flex;flex: 1;align-items: center;">
        <mat-label style="font-weight: bold;" class="get-label">Select Type</mat-label>
      </div>
      <div style="display: flex;flex: 1;">
        <mat-radio-group style="display: flex;flex-direction: row;justify-content: space-between;flex:1"
          aria-label="Select an option" [(ngModel)]="SelectType">
          <mat-radio-button [value]="1">Paper Based Form</mat-radio-button>
          <mat-radio-button [value]="2">Digital Form</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- <div style="display: flex;flex-direction: row;justify-content: space-between;height: 50px;">
      <div style="display: flex;flex-direction: row;flex:1;align-items: center;">
        <span style="font-weight: bold;">State</span>
      </div>
      <div style="display: flex;flex-direction: row;flex:1;align-items: center;
      height: 50px;
      background-color: gainsboro;">
        <mat-select style="flex: 1;font-size: larger;" 
          placeholder="Select State" [(ngModel)]="State">

          <mat-option *ngFor="let _type of data.States" [value]="_type.ID">
            {{_type.StateName}}
          </mat-option>
        </mat-select>
      </div>
    </div> -->

  </div>

  <div *ngIf="ShowFormAdd == true">
    <div class="example-full-width" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;" class="get-label">Name</mat-label>
      <input style="width: 500px;" type="text" matInput placeholder="Name" [(ngModel)]="Name" class="get-Input">
    </div>

    <div class="example-full-width" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;" class="get-label">Description</mat-label>
      <input style="width: 500px;" type="text" matInput placeholder="Description" [(ngModel)]="Description"
        class="get-Input">
    </div>

    <div class="example-full-width" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
      <mat-label style="font-weight: bold;" class="get-label">Uploaded file</mat-label>
      <div><span>{{Filename}}</span></div>
    </div>

    <div class="example-full-width" style="display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;margin-top: 12px;">

      <mat-label style="font-weight: bold;">Pick a different file</mat-label>

      <div>
        <label>
          <input type="file" name="upload" accept="application/pdf,application/vnd.ms-excel"
            (change)="onFileChanged($event);">
        </label>
      </div>

    </div>
  </div>
</div>

<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>

  <button [disabled]="SelectType == '0'" style="margin-left: 20px;" class="button button--primary"
    (click)="onSubmitClick()" [disabled]="Name == null" cdkFocusInitial>
    <span class="button__text">Submit</span>
  </button>
</div>